export const replacePhoneCodeOnMask = (
  mask: string,
  phoneCode?: string,
): string => {
  if (!phoneCode || !mask) {
    return '';
  }

  if (!mask.includes('#')) {
    return '';
  }

  let codeLength = phoneCode?.length || 0;

  const template = mask.replace(/^[^\#]+/, '');

  let result = '';
  for (const char of template) {
    if (char === '#') {
      if (codeLength) {
        codeLength--;
      } else {
        result = `${result}${char}`;
      }
    } else {
      result = `${result} `;
    }
  }
  result = result.replace(/\s+/g, ' ');
  return result.trim();
};
